export const getColorDiff = (diffStatus, error) => {
  if (diffStatus === 'new') return 'var(--success)'
  if (diffStatus === 'changed') return 'var(--warning)'
  if (error) return 'var(--danger)'
  return null
}
